module.exports = __webpack_public_path__ + "static/MAIN_SHOW_BREAK_6_EXTRA_PERFORMANCE-a4cd03486d980c4f18aeafbac8604785.mp4";